import { useState, useEffect ,useRef} from 'react'
import axios from 'axios'
import { useLocation, useNavigate } from 'react-router-dom';
import TransactionForm from './components/TransactionForm'
import TransactionList from './components/TransactionList'
import BudgetSuggestion from './components/BudgetSuggestion'
import NavbarDashborad from './components/Navbar'
import DownloadReport from './components/DownloadReport'
import SavingPlan from './components/SavingPlan'
import Setting from './components/Setting';
import { useTranslation } from 'react-i18next'
import LanguageDropdown from '../HomePage/components/LanguageDropdown';

function Dashboard() {
  const [activeSection, setActiveSection] = useState('dashboard')
  const [transactions, setTransactions] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [refreshCount, setRefreshCount] = useState(0)
  const [menuOpen, setMenuOpen] = useState(false) // For mobile menu
  const [financeSummary, setFinanceSummary] = useState({
    totalEarning: 0,
    totalCharge: 0,
    profit: 0
  })
  const { t } = useTranslation()
   const navigate = useNavigate();
  const location = useLocation();
   const prevPath = useRef(location.pathname);
// Detect route changes and remove token only when leaving /dashboard
  useEffect(() => {
    return () => {
      if (prevPath.current === '/dashboard' && location.pathname !== '/dashboard') {
        localStorage.removeItem('token');
      }
    };
  }, [location.pathname]);

  // Redirect if no token
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login', { replace: true });
    }
  }, [location.pathname, navigate]);
  const handleTransactionSuccess = () => {
  setRefreshCount((prev) => prev + 1) // triggers re-fetch in BudgetSuggestion
}

  const fetchFinanceSummary = async () => {
    const token = localStorage.getItem('token')
    const today = new Date()
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)

    try {
      const response = await axios.get(
        `https://trakersmallbusienss-3.onrender.com/api/auth/summary?start=${firstDayOfMonth.toISOString()}&end=${today.toISOString()}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      )
      setFinanceSummary(response.data)
    } catch (err) {
      console.error(err)
      setError('Failed to load finance summary')
    }
  }

  const fetchTransactions = async () => {
    const token = localStorage.getItem('token')
    try {
      const response = await axios.post(
        'https://trakersmallbusienss-3.onrender.com/api/auth/AllTransctions',
        {},
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      )
      setTransactions(response.data.AllTransctions)
    } catch (err) {
      console.error(err)
      setError('Failed to load transactions')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchFinanceSummary()
    fetchTransactions()
  }, [])
  const handleLogout = () => {
    localStorage.removeItem('token')
    navigate('/login')
  }
  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      {/* Mobile Hamburger Menu */}
      <div className="md:hidden bg-gray-100 dark:bg-gray-900 p-4 flex justify-between items-center">
        <span className="logo-text">
          {t('Dashboard.app.logoPart1')}
          <span className="logo-accent">{t('Dashboard.app.logoPart2')}</span>
        </span>
        <button
          className="text-gray-800 dark:text-white"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? '✖' : '☰'}
        </button>
      </div>

      {/* Sidebar */}
      <aside
        className={`bg-gray-100 dark:bg-gray-900 p-6 w-full md:w-64 transition-all duration-300 ease-in-out z-10 ${
          menuOpen ? 'block' : 'hidden'
        } md:block min-h-screen`}
      >
        <h2 className="text-xl font-bold text-gray-800 dark:text-white mb-4">
          {t('Dashboard.menu.title')}
        </h2>
  <ul className="space-y-3">
  {[
    { key: 'dashboard', label: '📊 ' + t('Dashboard.menu.dashboard') },
    { key: 'generatePDF', label: '📄 ' + t('Dashboard.menu.generatePDF') },
    { key: 'Smart Budget', label: '💡 ' + t('Dashboard.menu.smartBudget') },
     { key: 'budgetPlanner', label: '💼 ' + t('Dashboard.menu.budgetPlanner') },
    { key: 'settings', label: '⚙️ ' + t('Dashboard.menu.settings') },
    { key: 'importTransactions', label: '📥 ' + t('Dashboard.menu.importTransactions') },
    { key: 'exportTransactions', label: '📤 ' + t('Dashboard.menu.exportTransactions') },
    { key: 'analytics', label: '📈 ' + t('Dashboard.menu.analytics') },
    { key: 'recurringPayments', label: '💸 ' + t('Dashboard.menu.recurringPayments') },
   
  ].map((item) => {
    const disabledKeys = ['importTransactions', 'exportTransactions', 'analytics', 'recurringPayments']
    const isDisabled = disabledKeys.includes(item.key)

    return (
      <li key={item.key}>
        <button
          disabled={isDisabled}
          className={`w-full text-left px-4 py-2 rounded transition ${
            isDisabled
              ? 'text-gray-400 bg-gray-100 cursor-not-allowed'
              : activeSection === item.key
              ? 'bg-blue-500 text-white'
              : 'hover:bg-blue-100 dark:hover:bg-gray-800'
          }`}
          onClick={() => {
            if (!isDisabled) {
              setActiveSection(item.key)
              setMenuOpen(false)
            }
          }}
        >
          {item.label}
        </button>
      </li>
    )
  })}
</ul>
<div className="mt-6 md:hidden">
  <LanguageDropdown />
</div>

      </aside>

      {/* Main Content */}
      <main className="flex-1 p-4 sm:p-8 bg-white dark:bg-gray-950">
        {activeSection === 'dashboard' && (
          <>
            <div className="flex justify-between items-center mb-6">
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                {t('Dashboard.dashboard.title')}
              </h1>
              <div className='flex items-center space-x-4 tracking-wide'>
                 <button
                onClick={handleLogout}
                className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded m-3"
              >
                {t('Dashboard.dashboard.logout')}
              </button>
                <div className="hidden md:block ">
                  <LanguageDropdown />
                </div>
              </div>
             
               
            </div>

            {error && (
              <div className="bg-red-100 dark:bg-red-900 border border-red-400 text-red-700 dark:text-red-200 px-4 py-3 rounded relative mb-6">
                {error}
              </div>
            )}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
              <div className="card bg-green-50 dark:bg-green-900/20 border border-green-100 dark:border-green-800">
                <h3 className="text-lg font-medium text-green-800 dark:text-green-200 mb-2">
                  {t('Dashboard.dashboard.totalIncome')}
                </h3>
                <p className="text-3xl font-bold text-green-700 dark:text-green-300">
                  €{financeSummary.totalEarning.toFixed(2)}
                </p>
              </div>
              <div className="card bg-red-50 dark:bg-red-900/20 border border-red-100 dark:border-red-800">
                <h3 className="text-lg font-medium text-red-800 dark:text-red-200 mb-2">
                  {t('Dashboard.dashboard.totalExpenses')}
                </h3>
                <p className="text-3xl font-bold text-red-700 dark:text-red-300">
                  €{financeSummary.totalCharge.toFixed(2)}
                </p>
              </div>
              <div
                className={`card ${
                  financeSummary.profit >= 0
                    ? 'bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 text-blue-700 dark:text-blue-300'
                    : 'bg-orange-50 dark:bg-orange-900/20 border border-orange-100 dark:border-orange-800 text-orange-700 dark:text-orange-300'
                }`}
              >
                <h3 className="text-lg font-medium mb-2">{t('Dashboard.dashboard.profit')}</h3>
                <p className="text-3xl font-bold">€{financeSummary.profit.toFixed(2)}</p>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              <div className="lg:col-span-1">
                <TransactionForm
                  isLoading={isSubmitting}
                  onSubmitSuccess={() => {
                    fetchTransactions()
                    fetchFinanceSummary()
                  }}
                />
                <div className="mt-6"></div>
              </div>
              <div className="lg:col-span-2">
                {loading ? (
                  <div className="card flex justify-center items-center py-12">
                    <p className="text-gray-500 dark:text-gray-400">
                      {t('Dashboard.dashboard.loadingTransactions')}
                    </p>
                  </div>
                ) : (
                  <TransactionList transactions={transactions} />
                )}
              </div>
            </div>
          </>
        )}

        {activeSection === 'generatePDF' && (
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
              {t('Dashboard.generatePDF.title')}
            </h1>
            <DownloadReport />
          </div>
        )}

        {activeSection === 'importTransactions' && (
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
              {t('Dashboard.importTransactions.title')}
            </h1>
          </div>
        )}

        {activeSection === 'exportTransactions' && (
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
              {t('Dashboard.exportTransactions.title')}
            </h1>
          </div>
        )}

        {activeSection === 'analytics' && (
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
              {t('Dashboard.analytics.title')}
            </h1>
          </div>
        )}

        {activeSection === 'recurringPayments' && (
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
              {t('Dashboard.recurringPayments.title')}
            </h1>
          </div>
        )}

        {activeSection === 'budgetPlanner' && (
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
              {t('Dashboard.budgetPlanner.title')}
            </h1>
            <SavingPlan />
          </div>
        )}

        {activeSection === 'settings' && (
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
              {t('Dashboard.settings.title')}
            </h1>
            <Setting />
          </div>
        )}

        {activeSection === 'Smart Budget' && (
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
              {t('Dashboard.smartBudget.title')}
            </h1>
            <BudgetSuggestion refreshSignal={refreshCount} />
          </div>
        )}
      </main>
    </div>
  )
}

export default Dashboard
